import { useState, useEffect } from 'react'
import { useSsrContext } from './hooks/useSsrContext'

export const MOBILE_VIEW_BREAKDOWN = '800px'

const useMediaQuery = () => {
  const query = `(max-width: ${MOBILE_VIEW_BREAKDOWN})`
  const ssrContext = useSsrContext()
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(query).matches
      : (ssrContext.isMobileUA ?? false),
  )

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const mediaQueryList = window.matchMedia(query)

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQueryList.addEventListener('change', listener)

    return () => {
      mediaQueryList.removeEventListener('change', listener)
    }
  }, [query])

  return matches
}

export default useMediaQuery
